<script>
import { defineComponent } from "vue";
import { useUserStore } from "@/stores/user";
import { mapState } from "pinia";
import shiftService from "@/services/shift.service";
import { useAlertsStore } from "@/stores/alerts.js";
import { mapActions } from "pinia/dist/pinia.esm-browser.js";
import LoadingButton from "@/components/LoadingButton.vue";
import { useConfigStore } from "@/stores/config";
import ConfirmModal from "@/components/ConfirmModal.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default defineComponent({
  name: 'HomeView',
  components: { LoadingButton, HeadlineComponent, ConfirmModal },
  data() {
    return {
      events: []
    }
  },
  async beforeRouteEnter(to, from, next) {
    let events = {}
    try {
      let response = await shiftService.my()
      events = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add('danger', "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
    next(vm => {
      vm.events = events;
    })
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: 'add' }),
    async cancel(shift, task) {
      shift.loading = true;
      if (await this.$refs.confirmModal.show('Schicht absagen', `Soll die Schicht wirklich abgesagt werden?`)) {
        try {
          await shiftService.cancel(shift.event_id, shift.id)
          for (let i = 0; i < task.shifts.length; i++) {
            if (task.shifts[i].id === shift.id) {
              task.shifts.splice(i, 1);
              break;
            }
          }
          this.addAlert('success', 'Du hast deine Schicht erfolgreich abgesagt.');
        } catch (e) {
          if (e) {
            Sentry.captureException(e);
            this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
            window.scrollTo(0, 0);
          }
        }
      }
      shift.loading = false;
    }
  },
  computed: {
    ...mapState(useUserStore, ['user']),
    ...mapState(useConfigStore, ['dashboard_text'])
  }
})
</script>

<template>
  <teleport to="#modalTeleport">
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </teleport>
  <HeadlineComponent>Hey {{ user.first_name }}! Schön dich zu sehen.</HeadlineComponent>
  <div v-html="dashboard_text" class="quill-generated-text"></div>

  <h2 v-if="!events.length">Bisher hast du keine Schichten</h2>
  <template v-if="events.length">
    <h2>Deine Schichten</h2>
    <template v-for="event of events">
      <h3> {{ event.name }}</h3>
      <template v-for="team of event.teams">
        <template v-for="task of team.tasks">
          <div v-for="shift of task.shifts" :key="shift.id" class="mt-2 myshifts">
            <span>{{ $filters.formatDate(shift.start, 'HH:mm') }} - {{ $filters.formatDate(shift.end, 'HH:mm') }}</span>
            {{ team.name }} — {{ task.name }}
            <LoadingButton @click="cancel(shift, task)" class="btn-danger btn-sm ml-2" :loading="shift.loading">Absagen
            </LoadingButton>
          </div>
        </template>
      </template>
    </template>
  </template>
</template>

<style lang="scss" scoped>
.myshifts {
  span {
    width: 100px;
    display: inline-block
  }
}
</style>
